module.exports = __webpack_public_path__ + "assets/img/acd6-yt.svg";